<app-rc-dialog-wrapper noClose="true">
  <div class="email-popin-wrapper">
    <div class="email-popin-content">
      <div class="email-popin-content-left">
        <ng-container>
          <h3 class="rc-title-gamma" i18n="@@invite-popin_title">Invite people</h3>
          <h3 class="rc-title-gamma">{{ (clinic$ | async).legalName || '' }}</h3>
          <p class="rc-paragraph" i18n="@@invite-popin_desc">
            Send an email invitation to let a new user join your clinic space on Vet Services
          </p>
        </ng-container>
      </div>

      <div class="email-popin-content-right">
        <form class="rc-dialog-form__block" autocomplete="disabled" [formGroup]="contactForm">
          <!-- Email -->
          <div class="rc-dialog-form__input">
            <rc-field
              id="email-popin-input"
              [appDataCSmask]="true"
              formControlName="email"
              type="email"
              autocomplete="off"
              [label]="contactFields.email.placeholder"
              [error]="emailErrorMessage()"
            >
            </rc-field>
          </div>
          <!-- Actions -->
          <div class="rc-dialog-form__action rc-dialog-form__action--align-bottom">
            <div class="rc-button-group">
              <rc-link
                id="email-popin__cancel-button"
                data-qa="vs-account-collaborators-email-popin-button-cancel"
                variant="secondary"
                size="large"
                (click)="dismiss()"
              >
                {{ 'action_cancel' | translateKey }}
              </rc-link>
              <span class="rc-button__separator" i18n="@@action_separator">or</span>
              <rc-button
                id="email-popin__send-button"
                data-qa="vs-account-collaborators-email-popin-button-send-invitation"
                [disabled]="!contactForm.valid"
                (click)="submitForm()"
              >
                {{ 'action_send_invitation' | translateKey }}
              </rc-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</app-rc-dialog-wrapper>
